export const translations = {
  es: {
    close: 'Cerrar',
    messages: {
      success: 'Actualización exitosa',
      error: 'Ha ocurrido un error y no se han podido guardar los cambios'
    },
    login: {
      title: 'Iniciar sesión',
      username: 'Usuario',
      email: 'Correo electrónico',
      password: 'Contraseña',
      remember: 'Recordarme',
      'forgot-password': 'Recuperar contraseña',
      signup: 'Crear una cuenta',
      login: 'Iniciar',
      recovery: {
        title: 'Recuperar contraseña',
        description: 'Ingrese su correo electrónico para recuperar la contraseña',
        'back-login': 'Volver al inicio',
        recovery: 'Recuperar',
        success: 'Se ha enviado un correo electrónico para recuperar su contraseña'
      },
      reset: {
        title: 'Crea una nueva contraseña',
        reset: 'Generar'
      }
    },
    forms: {
      add: 'Agregar',
      back: 'Regresar',
      name: 'Nombre',
      description: 'Descripción',
      component: 'Componente',
      parent: 'Padre',
      category: 'Categoría',
      'no-category': 'Sin categoría',
      'parent-category': 'Categoría padre',
      'change-thumbnail': 'Cambiar miniatura',
      'only-images': 'Solo imágenes en formato {type}. Tamaño recomendado: {width} x {height} pixeles o un aspect ratio de {ratio}. Tamaño máximo del archivo es de {size}. Se puede cambiar luego.',
      'video-description': 'Videos en formato {type}. Con un aspect ratio de {ratio}. Tamaño máximo del archivo es de {size}. No se puede cambiar después.',
      'upload-video': 'Subir video',
      'update-upload-video': 'Subir otro video',
      'video-upload-on-save': 'El video se empezará a subir cuando de clic en guardar. No cierre esta ventana ni el navegador mientras el video se está subiendo.',
      'uploading-video': 'Subiendo video',
      'video-uploading-description': 'El video se está subiendo, no cierre esta ventana ni el navegador.',
      'video-cannot-update': 'Actualmente no es posible modificar el archivo de video, puedes editar otra información como el título, descripción, miniatura, etc.',
      video: 'Video',
      email: 'Correo',
      password: 'Contraseña',
      phone: 'Teléfono',
      address: 'Dirección',
      date: 'Fecha',
      value: 'Valor',
      profile: "Perfil",
      save: "Guardar",
      user: 'Usuario',
      users: 'Usuarios',
      plan: 'Plan',
      plans: 'Planes',
      'available-for-plans': 'Disponible para los planes',
      price: 'Precio',
      is_admin: 'Administrador',
      active: 'Activo',
      affiliation: 'Afiliación',
      'affiliation-date': 'Fecha de afiliación',
      'loading-save': "Guardando..",
      'sure-remove': '¿Está seguro que desea eliminar {name}?',
      'sure-remove-description': 'Al eliminar este registro ya no podrá recuperar información importante.',
      'no-record-remove': 'No hay registros para eliminar',
      'no-remove': 'No eliminar',
      'confirm-remove': 'Sí, eliminar',
      'data-removed': 'Se ha eliminado de forma correcta',
      'field-required': 'Campo obligatorio',
      'custom-field-required': '{name} es obligatorio',
      'is-required': 'Este campo es obligatorio',
      'must-valid': '{name} debe ser válido',
      'must-select': 'Debe seleccionar una opción',
      'new-record': 'Nuevo {name}',
      'edit-record': 'Editar {name}',
      'create-record': 'Crear {name}',
      'save-record': 'Guardar {name}',
      'saved-record': "Se ha guardado con éxito",
      yes: 'Sí',
      no: 'No',
      components: {
        component: 'Componente'
      },
      cycles: {
        cycle: 'Ciclo de facturación',
        monthly: 'Mensual',
        quarterly: 'Trimestral',
        biannual: 'Semestral',
        annual: 'Anual'
      },
      settings: {
        titles: {
          home: 'Página de inicio'
        },
        home: {
          title: 'Título para mostrar',
          description: 'Descripción en la página inicial',
          'show-video': 'Mostrar video en la página de inicio',
          'show-components': 'Mostrar lista de componentes en la página de inicio',
          'show-news': 'Mostrar una lista de videos nuevos',
          'news-days': 'Días para ser considerado como nuevo',
          'show-button': 'Mostrar botón para ir a un video o categoría',
          'button-type': 'Tipo de botón',
          'button-url': 'Recurso',
          'button-text': 'Texto del botón'
        }
      }
    },
    dashboard: {
      titles: {
        components: 'Explora la biblioteca de contenido',
        news: 'Videos publicados recientemente'
      }
    },
    library: {
      titles: {
        main: 'Explora la biblioteca de recursos',
        'by-type': 'Explora los recursos disponibles en {name}'
      },
      subtitles: {
        components: 'Lista de componentes',
        categories: 'Lista de categorías',
        videos: 'Videos disponibles en esta categoría'
      },
      breadcrumb: {
        main: 'Componentes'
      },
      messages: {
        'no-results': 'No se han encontrado recursos en esta sección.'
      },
      tooltips: {
        'add-favorite': 'Seleccionar como favorito',
        'remove-favorite': 'Quitar de mis favoritos',
        'play': 'Reproducir video'
      }
    },
    explore: {
      titles: {
        main: 'Explora todos los recursos de la biblioteca'
      },
      labels: {
        search: 'Buscar videos'
      }
    },
    favorites: {
      titles: {
        main: 'Explora los videos que has marcado como favoritos'
      },
      messages: {
        'no-results': 'Todavía no has agregado videos favoritos. Explora videos y agregalos a esta lista para guardarlos aquí.'
      },
      buttons: {
        explore: 'Explorar'
      }
    },
    'video-player': {
      buttons: {
        back: 'Regresar',
        favorite: 'Favorito',
        'close-menu': 'Cerrar menú'
      }
    },
    profile: {
      account: {
        title: 'Configurar cuenta'
      },
      security: {
        title: 'Seguridad',
        description: 'Solicita el cambio de contraseña de tu cuenta, te enviaremos un correo con un enlace para cambiarla.',
        warning: 'Si solicitas el cambio de contraseña, se cerrará tu sesión.'
      }
    },
    billing: {
      titles: {
        main: 'Historial de facturación',
        'pending-payment': 'Tiene un pago pendiente',
        'pay-information': 'Información del pago',
        'next-payment': 'Próximo pago',
        preference: 'Renovación del plan {name}'
      },
      messages: {
        'no-results': 'No se encontró facturación',
        'pending-payment': 'Su periodo de suscripción caducó el',
        'renew-suscription': 'Renueve la suscripción para tener acceso al contenido.',
        'next-payment': 'Su próxima fecha de pago es el',
        'renew-next-suscription': 'Renueve la suscripción para continuar teniendo acceso al contenido.',
        wait: 'Espere un momento por favor.'
      },
      information: {
        value: 'Valor',
        plan: 'Plan suscrito',
        'expiration-date': 'Fecha de expiración',
        'coverage-date': 'Cobertura de la afiliación'
      },
      buttons: {
        pay: 'Pagar'
      },
      table: {
        headers: {
          date: 'Fecha',
          value: 'Valor',
          plan: 'Plan',
          reference: 'Referencia',
          coverage: 'Cobertura'
        }
      },
      tooltips: {
        details: 'Ver detalles'
      }
    },
    payment: {
      titles: {
        main: 'Información sobre el pago'
      },
      messages: {
        'id-transaction': 'ID de la Transacción',
        reference: 'Referencia',
        date: 'Fecha',
        value: 'Valor',
        status: 'Estado'
      },
      status: {
        approved: 'Aprobado',
        rejected: 'Rechazado',
        pending: 'Pendiente'
      }
    },
    inactive: {
      messages: {
        inactive: 'Usuario deshabilitado. Por favor comuniquese con el administrador'
      }
    },
    menu: {
      admin: {
        users: 'Gestión de usuarios',
        categories: 'Gestión de categorías',
        videos: 'Gestión de Videos',
        plans: 'Planes',
        components: 'Componentes',
        settings: 'Configuración',
        subtitle: 'Área administrativa'
      },
      customer: {
        home: 'Inicio',
        library: 'Biblioteca',
        explore: 'Explorar',
        favorites: 'Mis favoritos',
        'my-account': 'Mi cuenta',
        billing: 'Facturación'
      },
      top: {
        logout: 'Cerrar sesión',
        profile: 'Mi cuenta'
      }
    },
    results: {
      'image-uploaded': 'Imagen actualizada',
      'video-uploaded': 'El video se ha subido exitosamente'
    },
    errors: {
      'image-type': 'La imagen seleccionada no es de tipo {type}',
      'image-dimensions': 'La imagen debe tener un tamaño de {width} x {height} pixeles',
      'image-size': 'La imagen debe tener un tamaño máximo de {size}',
      'video-size': 'El archivo de video debe tener un tamaño máximo de {size}',
      'video-type': 'El archivo de video debe ser {type}',
      'upload-video': 'Debe seleccionar un video para subir, en el futuro no podrá editar el video.',
      'upload-failed': 'Ocurrió un error al subir el archivo, vuelva a intentarlo',
      remove: 'Ocurrió un error al eliminar, vuelva a intentarlo',
      auth: {
        'wrong-password': 'El correo o la contraseña no son válidos, vuelva a intentarlo',
        'invalid-email': 'El correo electrónico no es válido',
        'user-not-found': 'El usuario no existe',
        'user-disabled': 'Usuario deshabilitado, contacte al administrador'
      },
      billing: {
        'plan-not-found': 'No se ha encontrado el plan asociado'
      },
      payment: {
        empty: 'No se han encontrado datos.',
        'not-found': 'No se ha encontrado la referencia de pago',
        rejected: 'Su transacción fue rechazada.',
        pending: 'Transacción pendiente, en un momento se verificará su pago.',
        unknow: 'No pudimos obtener respuesta de la transacción, por favor contacte al administrador'
      }
    }
  }
}
